import { pdfjs } from 'react-pdf';

/**
 * Configure the pdf.js worker once, for every component that renders a PDF.
 *
 * Imported for its side effect. Shared because `GlobalWorkerOptions` is process
 * global — two components each setting it would work by luck of import order,
 * and silently break the moment that order changed.
 *
 * The worker is served from `public/`, copied there verbatim from the installed
 * `pdfjs-dist` by `scripts/copy-pdf-worker.js` before every build and dev start.
 * So it is still self-hosted, still version-locked to the API that uses it, and
 * still works offline — no CDN, which would trade this for a version skew that
 * corrupts rendering, or an outage nobody here controls.
 *
 * It is NOT resolved with `new URL('pdfjs-dist/build/pdf.worker.min.mjs',
 * import.meta.url)`, which is the documented approach and produced a silently
 * broken artifact: CRA ran the worker through babel-loader (injecting
 * `@babel/runtime` helper imports) and then emitted it as a raw asset, so those
 * imports were never resolved. The shipped file carried absolute paths into the
 * build machine's home directory, which the browser resolved against the site
 * origin and got index.html back. Nothing fails until a real deployment, and
 * the error names files nobody wrote. `public/` has no loader in the path.
 *
 * The `?v=` is a cache-buster: the filename in `public/` is not content-hashed
 * the way bundled assets are, so without it a pdfjs upgrade would leave
 * browsers running the previous worker against the new API.
 */
pdfjs.GlobalWorkerOptions.workerSrc =
  `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js?v=${pdfjs.version}`;

export default pdfjs;
